import React from 'react';
import { X, CheckCircle } from 'lucide-react';

type TFn = (key: string) => string;

interface CheckoutFormSuccessViewProps {
  t: TFn;
  submittedReservationId: string;
  submittedTotalAmount?: string;
  onClose: () => void;
}

const CheckoutFormSuccessView: React.FC<CheckoutFormSuccessViewProps> = ({
  t,
  submittedReservationId,
  submittedTotalAmount,
  onClose,
}) => (
  <div className="h-full w-full bg-white border-l border-gray-200 shadow-lg overflow-hidden flex flex-col">
    <div className="h-full flex flex-col overflow-hidden">
      <div
        className="flex flex-shrink-0 items-center justify-between border-b bg-gradient-to-r from-nature-50 to-white p-6"
        style={{ paddingTop: 'max(1.5rem, env(safe-area-inset-top, 0px))' }}
      >
        <h2 className="text-2xl font-bold text-gray-900">{t('guestReservation.confirmation.title')}</h2>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto overscroll-y-contain touch-pan-y p-6 pb-[max(1.25rem,env(safe-area-inset-bottom,0px))]">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
            <CheckCircle className="w-10 h-10 text-green-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">{t('guestReservation.confirmation.title')}</h3>
          <p className="text-gray-600">{t('guestReservation.confirmation.subtitle')}</p>
        </div>

        <div className="bg-gray-50 rounded-lg p-4 mb-4">
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-600">{t('guestReservation.confirmation.reservationId')}</span>
              <span className="font-semibold">{submittedReservationId}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{t('common.total')}</span>
              <span className="font-semibold text-nature-600">{submittedTotalAmount}</span>
            </div>
          </div>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-lg p-4">
          <p className="text-green-800 text-sm">{t('guestReservation.confirmation.statusMessage')}</p>
        </div>
      </div>
    </div>
  </div>
);

export default CheckoutFormSuccessView;
